import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2, FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

export default function BillingTab() {
  const { t } = useTranslation();
  const [transactions, setTransactions] = useState(null);

  useEffect(() => {
    api.get("/payments/billing/me").then(({ data }) => setTransactions(data));
  }, []);

  if (!transactions) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#4ba3b7]" /></div>;

  return (
    <div data-testid="producer-billing-tab">
      {transactions.length === 0 ? (
        <p className="text-center py-16 text-[#2B2B2B]/50" data-testid="producer-billing-empty-message">{t("search.noResults")}</p>
      ) : (
        <div className="space-y-2">
          {transactions.map((tx) => (
            <div key={tx.id} className="flex items-center justify-between bg-white rounded-xl border border-black/5 p-4 text-sm" data-testid={`billing-transaction-${tx.id}`}>
              <div>
                <p className="font-semibold">{tx.type === "credits" ? t("credits.buyCredits") : t("offer.boostThisOffer")}</p>
                <p className="text-xs text-[#2B2B2B]/50">{new Date(tx.created_at).toLocaleDateString()}</p>
              </div>
              <div className="flex items-center gap-3">
                {tx.invoice_url && (
                  <a href={tx.invoice_url} target="_blank" rel="noopener noreferrer"
                     className="flex items-center gap-1 text-xs font-semibold text-[#4ba3b7] hover:underline"
                     data-testid={`billing-invoice-link-${tx.id}`}>
                    <FileText className="h-3.5 w-3.5" /> {t("credits.downloadInvoice")}
                  </a>
                )}
                <span className="font-semibold">{tx.amount}&euro;</span>
                <Badge className={tx.status === "paid" ? "bg-[#34C759]/10 text-[#34C759] border-0" : "bg-black/5 text-[#2B2B2B]/60 border-0"}>
                  {tx.status}
                </Badge>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
